import {
  getMoneyFormatter as sharedGetMoneyFormatter,
  getNumberFormatter as sharedGetNumberFormatter,
  getPercentageFormatter as sharedGetPercentageFormatter
} from "shared/utils/formatter";

export { formatUrl } from "shared/utils/formatter";

// These bind the shared, locale parameterized formatters to the current UI locale.
export const getMoneyFormatter = (options?: Intl.NumberFormatOptions) =>
  sharedGetMoneyFormatter(serverReference.culture.uiLocale, options);

export const getPercentageFormatter = (decimalDigits: number) =>
  sharedGetPercentageFormatter(serverReference.culture.uiLocale, decimalDigits);

export const getNumberFormatter = () =>
  sharedGetNumberFormatter(serverReference.culture.uiLocale);
